/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/no-unknown-property */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';

export default class InputFile extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e);
  }

  get label() {
    if (this.props.loading) {
      return 'Enviando...';
    }
    return this.hasFiles() ? this.props.files[0].name : this.props.label;
  }

  hasFiles() {
    return this.props.files && this.props.files.length > 0;
  }

  render() {
    const {
      id,
      name,
      fileExtension,
      multipart,
      maxSizeFiles,
      textHelper,
      multiple,
      error,
    } = this.props;

    return (
      <div className="input-file">
        <div className="input-group">
          <div className="custom-file">
            <input
              ref={node => {
                this.inputFile = node;
              }}
              onChange={this.onChange}
              type="file"
              name={name}
              className="custom-file-input"
              id={id}
              accept={fileExtension}
              multipart={multipart}
              multiple={multiple}
            />
            <label
              className="input-file__label custom-file-label"
              htmlFor={id}
              aria-describedby={id}
            >
              {this.label}
            </label>
          </div>
        </div>

        {error && (
          <div className="invalid-feedback" style={{ display: 'block' }}>
            <div className="error-message">
              houve um erro ao enviar o arquivo
            </div>
          </div>
        )}

        {textHelper ? (
          <small className="input-file__helper">{textHelper}</small>
        ) : (
          <small className="input-file__helper">
            No formato {fileExtension} com o tamanho de até {maxSizeFiles}.
          </small>
        )}
      </div>
    );
  }
}

InputFile.defaultProps = {
  onChange() {},
  label: 'Escolher arquivo',
  name: 'attached',
  multipart: true,
  fileExtension: '',
  maxSizeFiles: '10mb',
  multiple: true,
  files: [],
  loading: false,
  error: false,
};

InputFile.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  fileExtension: PropTypes.string,
  multipart: PropTypes.string,
  maxSizeFiles: PropTypes.string,
  textHelper: PropTypes.string,
  files: PropTypes.arrayOf(),
  multiple: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};
